function SliderProgram() {
	this.build();
	barbaCallbacks.push(this);
}

SliderProgram.prototype.build = function () {
	$('.slider-program').each(function () {
		let slider = $(this);
		let nav = $('.slider-nav[data-slider="' + slider.attr('id') + '"]');
		let arrows = nav.find('.slider-nav--arrow');


		if( $(this).attr('id') === "slider-program--single" ){
			let direction = null;
			slider.on('init', function () {
				appearOnScroll.build();
			}).slick({
				dots: false,
				arrows: false,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				initialSlide: 1
			}).on('afterChange', function (event, slick, currentSlide) {
				nav.find('li.active').removeClass('active');
				nav.find('li:eq(' + (currentSlide-1) + ')').addClass('active');
			}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				if (Math.abs(nextSlide - currentSlide) == 1) {
					direction = (nextSlide - currentSlide > 0) ? "right" : "left";
				} else {
					direction = (nextSlide - currentSlide > 0) ? "left" : "right";
				}
				if( direction === "left" && currentSlide !== nextSlide ){
					$("#slider-program--perspective").slick('slickPrev');
				}
				if( direction === "right" && currentSlide !== nextSlide ){
					$("#slider-program--perspective").slick('slickNext');
				}
			});
		} else {
			slider.on('init', function () {
				appearOnScroll.build();
			}).slick({
				dots: false,
				arrows: false,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				swipe: false
			});
		}

		$('ul li span', nav).on('click', function () {
			slider.slick('slickGoTo', $(this).parent('li').index());
		});

		arrows.each(function () {
			$(this).on('click', function () {
				if ($(this).hasClass('slider-nav--arrow--next')) {
					slider.slick('slickNext');
				} else {
					slider.slick('slickPrev');
				}
			});
		});
	});

	let typologies = $('.table-header-collapse');
	typologies.each( function() {
		let number = $(this).next('.table-body-collapse').find('.table-line');
		$(this).find('.table-head-number').html( '('+number.length+' lots disponibles)' );
		$(this).on('click', function(){
			$(this).next('.table-body-collapse').slideToggle(400);
			$(this).toggleClass('active');
		});
	});

};
